import cn from "classnames";

// components
import NaicsCodesSection from "components/BusinessProfileSections/NaicsCodesSection/NaicsCodesSection";

// types
import { BusinessItem } from "types/results-panel.types";

// styles
import styles from "./NAICSSection.module.scss";

// types
import { NaicsProfile } from "types/profile.types";

type NaicsProps = {
  businessProfileData?: BusinessItem;
  naics?: NaicsProfile[];
};

export default function NAICSSection({ businessProfileData, naics }: NaicsProps) {
  return (
    <div className={styles["naics-section-root"]}>
      <h2 className={styles["heading"]}>NAICS codes</h2>
      <div className={cn(styles["section-content"], styles["space-y-6"])}>
        <h3 className={styles["title"]}>Information from SAM.gov</h3>
        <p className={cn(styles["desc"])}>
          NAICS codes come from this small business’s SAM.gov registration, and
          must be updated there.
        </p>
        <a
          href="https://www.sam.gov/"
          rel="noopener noreferrer"
          target="_blank"
          className="usa-link usa-link--external"
        >
          Log in to SAM.gov
        </a>

        <NaicsCodesSection naics={naics} businessProfileData={businessProfileData} omitTitle />
      </div>
    </div>
  );
}
